// The icon set (T-110): Lucide line icons at one stroke weight, curated here so that screens
// pick from a fixed vocabulary. Icons are decorative unless given a label.

import {
  Bell,
  ChartColumn,
  Check,
  ChevronDown,
  CircleAlert,
  Copy,
  Download,
  Film,
  House,
  KeyRound,
  Link2,
  Lock,
  LogOut,
  Menu,
  Plus,
  Search,
  Send,
  Settings,
  ShieldCheck,
  Upload,
  Users,
  Video,
  X,
  type LucideIcon,
} from "lucide-react";

export const icons = {
  alert: CircleAlert,
  assets: Film,
  bell: Bell,
  check: Check,
  chevronDown: ChevronDown,
  close: X,
  copy: Copy,
  demos: Send,
  download: Download,
  home: House,
  insights: ChartColumn,
  key: KeyRound,
  link: Link2,
  lock: Lock,
  menu: Menu,
  plus: Plus,
  record: Video,
  search: Search,
  security: ShieldCheck,
  settings: Settings,
  signOut: LogOut,
  upload: Upload,
  users: Users,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof icons;

export function Icon({ name, size = 18, label, className = "" }: { name: IconName; size?: number; label?: string; className?: string }) {
  const Component = icons[name];
  return (
    <Component
      size={size}
      strokeWidth={1.75}
      className={`shrink-0 ${className}`}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? "img" : undefined}
    />
  );
}
